module.exports = __webpack_public_path__ + "static/media/tip_arrow.7010dc5b.png";